import { render, staticRenderFns } from "./TehtavaDecisionDisplay.vue?vue&type=template&id=e0892aae"
import script from "./TehtavaDecisionDisplay.vue?vue&type=script&lang=js"
export * from "./TehtavaDecisionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports